import $ from "jquery";
import Inputmask from "inputmask";
//import blockUi from 'block-ui'

export default class Page {

    loadedHandlers = [];
    refreshHandlers = [];
    finishHandlers = [];
    displayedHandlers = [];

    constructor() {

        var prefix = window.addEventListener ? "" : "on";
        var eventName = window.addEventListener ? "addEventListener" : "attachEvent";

        window[eventName](prefix + 'load', () => { this.Loaded(); }, false);

        // https://tc39.github.io/ecma262/#sec-array.prototype.find
        //if (!Array.prototype.find) {
            Object.defineProperty(Array.prototype, 'find', {
                value: function (predicate) {
                    // 1. Let O be ? ToObject(this value).
                    if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                    }

                    var o = Object(this);

                    // 2. Let len be ? ToLength(? Get(O, "length")).
                    var len = o.length >>> 0;

                    // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                    if (typeof predicate !== 'function') {
                        throw new TypeError('predicate must be a function');
                    }

                    // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    var thisArg = arguments[1];

                    // 5. Let k be 0.
                    var k = 0;

                    // 6. Repeat, while k < len
                    while (k < len) {
                        // a. Let Pk be ! ToString(k).
                        // b. Let kValue be ? Get(O, Pk).
                        // c. Let testResult be ToBoolean(? Call(predicate, T, � kValue, k, O �)).
                        // d. If testResult is true, return kValue.
                        var kValue = o[k];
                        if (predicate.call(thisArg, kValue, k, o)) {
                            return kValue;
                        }
                        // e. Increase k by 1.
                        k++;
                    }

                    // 7. Return undefined.
                    return undefined;
                }
            });
        //}
        
        var Elos = {
            init: function (settings, self) {
                var config = {
                };
                if (settings) {
                    $.extend(config, settings);
                }

                //if (!window.PageInitialized) {
                //    Elos.sidebar(config);
                //    Elos.binders(self);
                //}

                //window.PageInitialized = true;
            },

            //sidebar: function (config) {
            //    //$('.submenu').hide();
            //    //$('.aberto .submenu').show();

            //    $('#menu-icon').click(function () {
            //        if ($('#sidebar').hasClass('sidebar-min')) {
            //            $('#sidebar').removeClass('sidebar-min');
            //            $('#sidebar').addClass('sidebar-sticky');

            //            $('main#conteudo').removeClass('col-lg-11');
            //            $('main#conteudo').addClass('col-lg-10');
            //        }
            //        else {

            //            $('#sidebar').removeClass('sidebar-sticky');
            //            $('#sidebar').addClass('sidebar-min');

            //            $('main#conteudo').removeClass('col-lg-10');
            //            $('main#conteudo').addClass('col-lg-11');
            //        }
            //    });

            //    $('.submenu').on('show.bs.collapse', function () {
            //        $(this).parents('.itens').addClass('aberto');
            //    })

            //    $('.submenu').on('hide.bs.collapse', function () {
            //        $(this).parents('.itens').removeClass('aberto');
            //    })

            //    let currentRoute = window.location.pathname;

            //    if (currentRoute == "/") {
            //        currentRoute = "/participante";
            //    }

            //    const selected = $("#sidebar a[href$='" + currentRoute + "']");
            //    selected.addClass("selecionado");
            //    selected.parents('.submenu').collapse('show');
            //    selected.parents('.submenu').parents('.itens').addClass('aberto');

            //},

            //binders: function (self) {
            //    $(document).bind("ajaxSend", () => {
            //        self.BlockUI();
            //    }).bind("ajaxStop", function () {
            //        $.unblockUI();
            //    });
            //}

        };
        var config = {};

        Elos.init(config, this);
    }

    BlockUI() {
        $.blockUI({
            message: '<div><span>Carregando...</span></div>',
            overlayCSS: {
                backgroundColor: '#FFF',
                opacity: 0.95,
                cursor: 'wait'
            },
            baseZ: 10000,
            css: {
                border: 0,
                padding: 0,
                backgroundColor: 'transparent'
            }
        });
    }

    MaskTypeRender(className, options) {

        let items = document.getElementsByClassName(className)

        for (var i = 0; i < items.length; i++) {

            //var maskHandler = new MaskedTextBox({
            //    mask: mask
            //});

            var maskHandler = new Inputmask(options);


            if (!items[i].id)
                items[i].id = this.GuidGenerator(className)


            maskHandler.mask(items[i]);
            //maskHandler.appendTo('#' + items[i].id)
        }
    }

    GuidGenerator1(prefix) {
        var S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return prefix + (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
    }


    On(eventName, handler) {

        switch (eventName) {
            case "loaded":
                return this.loadedHandlers.push(handler);
            case "refresh":
                return this.refreshHandlers.push(handler);
            case "finish":
                return this.finishHandlers.push(handler);
            case 'displayed':
                return this.displayedHandlers.push(handler);
            case "somethingElse":
                return false; //alert('write something for this event :)');
        }
    }

    Loaded() {
        this.Fire(this.loadedHandlers);

    }

    Displayed() {
        this.Fire(this.displayedHandlers);
    }


    Refresh() {
        this.Fire(this.refreshHandlers);

    }

    Finish() {
        this.Fire(this.finishHandlers);
    }


    Fire(arrayHandler) {
        for (let i = 0; i < arrayHandler.length; i++) {
            let handler = arrayHandler[i];
            setTimeout(handler, 0);
        }


    }

    Confirm(title, msg, onConfirm, onCancel, size, textConfirm, textCancel) {

        /*
            xlarge / xl equivalent to col-md-12
            large / l equivalent to col-md-8 col-md-offset-2
            medium / m equivalent to col-md-6 col-md-offset-3
            small / s equivalent to col-md-4 col-md-offset-4
            xsmall / xs equivalent to col-md-2 col-md-offset-5
        */

        textConfirm = textConfirm == undefined ? 'Confirmar' : textConfirm;
        textCancel = textCancel == undefined ? 'Cancelar' : textCancel;

        if (!size) {
            size = 'col-md-4 col-md-offset-4';
        }

        $.confirm({
            title: title,
            content: msg,
            type: 'orange',
            typeAnimated: true,
            columnClass: size,
            buttons: {
                confirm: {
                    text: textConfirm,
                    btnClass: 'btn-orange',
                    action: function () {

                        this.close();

                        onConfirm();
                    }
                },
                close: {
                    text: textCancel,
                    action: function () {

                        this.close();

                        onCancel();
                    }
                }
            }
        });
    }


    Error(title, msg) {

        $.confirm({
            title: title,
            content: msg,
            type: 'red',
            columnClass: 'col-md-6 col-md-offset-3',
            typeAnimated: true,
            buttons: {
                close: {
                    text: 'OK',
                    btnClass: 'btn-red',
                    action: function () {
                        this.close();
                    }
                }
            }
        });

    }


    Success(title, msg, onClose) {

        $.confirm({
            title: title,
            content: msg,
            type: 'green',
            columnClass: 'col-md-6 col-md-offset-3',
            typeAnimated: true,
            buttons: {
                close: {
                    text: 'OK',
                    btnClass: 'btn-green',
                    action: function () {
                        this.close();

                        if (onClose) {
                            onClose();
                        }
                    }
                }
            }
        });

    }



    GuidGenerator(prefix) {

        if (prefix == undefined)
            prefix = '';

        var S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return prefix + (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
    }
}


export class SelectItem {

    Key;
    Value;

    constructor(key, value) {

        this.Key = key;

        if (typeof (value) == typeof (true))
            this.Value = value
        else
            this.Value = value || key;
    }

    static Map(arr) {
        return arr.map(item => new SelectItem(item.Key, item.Value))
    }
}

